import { createContext, useState,useEffect } from "react";
import { firebaseFire} from './services/Firebase'
import { addDoc,getDocs, query,collection,where} from 'firebase/firestore'
import { Maintenance } from "./models/Maintenance";
import  secureLocalStorage  from  "react-secure-storage";
export const MaintenanceContext = createContext();


export const MaintenanceProvider = ({ children }) => {
    const [curr] = useState(new Date());
    const [maintenance, setMaintenance] = useState(new Maintenance(curr.getTime().toString() ));
    const [loading] = useState(false);
    const [error] = useState({});
    useEffect( () => {
        let user = secureLocalStorage.getItem("user");
        if( user ){
            user  = JSON.parse(user);
            console.log(user);
            setMaintenance({...maintenance ,
                user:{
                    email:user.email,
                    name:user.nombre,
                    uid:user.uuid,
                    partner:user.partner
                }
            });
        }
        console.log(maintenance);
    },[]);
    const register  = ()  => {
        const maintenanceColl = collection(firebaseFire, 'mantenciones');
        return addDoc(maintenanceColl,maintenance);
    }

    const patentExist = async () => {
        try {
            const q = query(
                collection(firebaseFire, "vehiculos"),
                where("patente", "==",maintenance.patente)
            );
            const docsSnap = await getDocs(q);
            return docsSnap.docs.length > 0;
        } catch (error) {
            throw error;
        }
    };

    const ContextProviderValues = {
        loading,
        error,
        register,
        maintenance,
        setMaintenance,
        patentExist,
    };

    return (
        <MaintenanceContext.Provider value={ContextProviderValues}>
            {children}
        </MaintenanceContext.Provider>
    )
}
